import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-paper">
                <div className="font-mono text-xs text-ink-600">CHECKING SESSION…</div>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    if (roles && !roles.includes(user.role)) {
        const target =
            user.role === "admin"
                ? "/admin"
                : user.role === "advertiser"
                    ? "/advertiser"
                    : "/respondent";
        return <Navigate to={target} replace />;
    }
    return children;
}
